import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AbpHttpInterceptor } from 'abp-ng2-module';

import * as ApiServiceProxies from './service-proxies';
import { LoadingInterceptor } from '@shared/interceptors/loading.interceptor';

@NgModule({
    providers: [
        ApiServiceProxies.RoleServiceProxy,
        ApiServiceProxies.SessionServiceProxy,
        ApiServiceProxies.TenantServiceProxy,
        ApiServiceProxies.UserServiceProxy,
        ApiServiceProxies.TokenAuthServiceProxy,
        ApiServiceProxies.AccountServiceProxy,
        ApiServiceProxies.ConfigurationServiceProxy,
        ApiServiceProxies.AuditLogServiceProxy,
        ApiServiceProxies.JuridicalPersonServiceProxy,
        ApiServiceProxies.NaturalPersonServiceProxy,
        ApiServiceProxies.CompanyServiceProxy,
        ApiServiceProxies.CompanyRoleServiceProxy,
        ApiServiceProxies.DocumentTypeServiceProxy,
        ApiServiceProxies.NationalityServiceProxy,
        ApiServiceProxies.CountryServiceProxy,
        ApiServiceProxies.OccupationServiceProxy,
        ApiServiceProxies.MaritalStatusServiceProxy,
        ApiServiceProxies.NuptialsServiceProxy,
        ApiServiceProxies.MarriageRegimeServiceProxy,
        ApiServiceProxies.LocationServiceProxy,
        ApiServiceProxies.CompanyTypeServiceProxy,
        ApiServiceProxies.CurrencyServiceProxy,
        ApiServiceProxies.FunctionalLinkServiceProxy,
        ApiServiceProxies.HealthInsuranceServiceProxy,
        ApiServiceProxies.AttorneyInFactTypeServiceProxy,
        ApiServiceProxies.PositionServiceProxy,
        ApiServiceProxies.ShareTypeServiceProxy,
        ApiServiceProxies.WorkActivityServiceProxy,
        ApiServiceProxies.NotificationServiceProxy,
        ApiServiceProxies.UserNotificationSettingServiceProxy,
        ApiServiceProxies.LibraryServiceProxy,
        ApiServiceProxies.UserLibraryServiceProxy,
        ApiServiceProxies.AssetServiceProxy,
        ApiServiceProxies.AssetStateServiceProxy,
        ApiServiceProxies.TypeFieldServiceProxy,
        ApiServiceProxies.CustomFieldServiceProxy,
        ApiServiceProxies.CustomFieldOptionServiceProxy,
        ApiServiceProxies.TemplateServiceProxy,
        ApiServiceProxies.CategoryServiceProxy,
        ApiServiceProxies.ValueFieldServiceProxy,
        ApiServiceProxies.NoteServiceProxy,
        ApiServiceProxies.LogServiceProxy,
        ApiServiceProxies.UserTablePreferenceServiceProxy,
        ApiServiceProxies.ReminderServiceProxy,
        ApiServiceProxies.TaskServiceProxy,
        ApiServiceProxies.EventServiceProxy,
        ApiServiceProxies.TaskTemplateServiceProxy,
        ApiServiceProxies.ActivityServiceProxy,
        ApiServiceProxies.WorkflowServiceProxy,
        ApiServiceProxies.TipoInstServiceProxy,
        ApiServiceProxies.MonedaServiceProxy,
        ApiServiceProxies.RegionServiceProxy,
        ApiServiceProxies.PaisServiceProxy,
        ApiServiceProxies.EntidadServiceProxy,
        ApiServiceProxies.TipodeMoServiceProxy,
        ApiServiceProxies.TasaBaseServiceProxy,
        ApiServiceProxies.TasaRefServiceProxy,
        ApiServiceProxies.CuentaServiceProxy,
        ApiServiceProxies.ConceptoServiceProxy,
        ApiServiceProxies.ComisionServiceProxy,
        ApiServiceProxies.InstrumentoServiceProxy,
        ApiServiceProxies.TipDividServiceProxy,
        ApiServiceProxies.MovimientoServiceProxy,
        ApiServiceProxies.CotizacionServiceProxy,
        ApiServiceProxies.TipoPrecioServiceProxy,
        ApiServiceProxies.PrecioServiceProxy,
        ApiServiceProxies.PrecioValorServiceProxy,
        { provide: HTTP_INTERCEPTORS, useClass: AbpHttpInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true }
    ]
})
export class ServiceProxyModule { }
